import {User, Buildings} from "@phosphor-icons/react";


const ownerTypes = {
	
	
	types: [
		{
			label:"Private", 
			value:"private", 
			className:"owner-icon owner-private",
			icon: <User size={16} />
		},
		{
			label:"Company", 
			value:"company", 
			className:"owner-icon owner-company",
			icon: <Buildings size={16} />
		}
	],
	"get": function(value){
		
		const v = Array.isArray(value) ? value : [value];
		
		var res = [];
		
		v.forEach((val)=>{
			const r = this.types.find((a)=>{return a.value == val});
			if(r)
				res.push(r);
		});
		return res.length > 1 ? res : res[0];	
	},
};



export {ownerTypes};